<mat-card [formGroup]="form()">
    <mat-card-title class="section-title">
        Equipment Details
    </mat-card-title>

    <mat-card-content>
        <div class="row">
            <div class="col-sm-6">
                <div class="horizontal-form-field">
                    <label class="form-label">
                        {{displayNames["facility"]}}
                        <mat-icon class="icon-locked" svgIcon="lock" />
                    </label>
                    <mat-form-field class="full-width">
                         <input matInput formControlName="facility" readonly>
                        <mat-error *ngIf="getErrorMessage('facility') as errorMessage">{{ errorMessage }}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="horizontal-form-field">
                    <label class="form-label">
                        {{displayNames["facilityOwner"]}}
                        <mat-icon class="icon-locked" svgIcon="lock" />
                    </label>
                    <mat-form-field formGroupName="facilityOwner" class="full-width">
                        <input matInput formControlName="name" readonly>
                        <mat-error *ngIf="getErrorMessage('facilityOwner') as errorMessage">{{ errorMessage }}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="horizontal-form-field">
                    <label class="form-label">
                        {{displayNames["area"]}}
                        <mat-icon class="icon-locked" svgIcon="lock" />
                    </label>
                    <mat-form-field class="full-width">
                        <!-- <mat-select formControlName="area"></mat-select> -->
                        <input matInput formControlName="area" readonly>
                        <mat-error *ngIf="getErrorMessage('area') as errorMessage">{{ errorMessage }}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="horizontal-form-field">
                    <label class="form-label">
                        {{displayNames["consequenceRanking"]}}
                        <span class="required"></span>
                        <!-- <mat-icon class="icon-locked" svgIcon="lock" /> -->
                    </label>
                    <mat-form-field class="full-width">
                        <mat-select
                            formControlName="consequenceRanking"
                            [attr.aria-label]="displayNames['consequenceRanking']">
                            @for (option of consequencyRankings(); track $index) {
                                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                            }
                        </mat-select>
                        <mat-error *ngIf="getErrorMessage('consequenceRanking') as errorMessage">
                            {{ errorMessage }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="horizontal-form-field">
                    <label class="form-label">
                        {{displayNames["isEquipmentSafeguard"]}}
                        <span class="required"></span>
                    </label>
                    <mat-form-field class="full-width">
                        <mat-select
                            formControlName="isEquipmentSafeguard"
                            [attr.aria-label]="displayNames['isEquipmentSafeguard']">
                            @for (option of equipmentSafeguardOptions(); track $index) {
                                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                            }
                        </mat-select>
                        <mat-error *ngIf="getErrorMessage('isEquipmentSafeguard') as errorMessage">
                            {{ errorMessage }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            @if (isTDR()) {
                <div class="col-sm-6">
                    <div class="horizontal-form-field">
                        <label class="form-label">
                            {{displayNames["taskFrequency"]}}
                            <span class="required"></span>
                        </label>
                        <mat-form-field class="full-width">
                            <mat-select formControlName="taskFrequency">
                                @for (frequency of taskFrequencyOptions(); track $index) {
                                    <mat-option [value]="frequency.value">{{ frequency.label }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="getErrorMessage('taskFrequency') as errorMessage">{{ errorMessage }}</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="horizontal-form-field">
                        <label class="form-label">
                            {{displayNames["percentOverdue"]}}
                            <span class="required"></span>
                        </label>
                        <mat-form-field class="full-width">
                            <mat-select formControlName="percentOverdue">
                                @for (option of percentOverdueOptions(); track $index) {
                                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="getErrorMessage('percentOverdue') as errorMessage">{{ errorMessage }}</mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="horizontal-form-field">
                        <label class="form-label">
                            {{displayNames["assignedManagementAuthorizationLevel"]}}
                            <mat-icon class="icon-locked" svgIcon="lock" />
                        </label>
                        <mat-form-field class="full-width">
                            <input matInput formControlName="assignedManagementAuthorizationLevel" readonly>
                            <mat-error *ngIf="getErrorMessage('assignedManagementAuthorizationLevel') as errorMessage">
                                {{ errorMessage }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="horizontal-form-field">
                        <label class="form-label">{{displayNames["standbyMode"]}}</label>
                        <mat-form-field class="full-width">
                            <mat-select formControlName="standbyMode">
                                @for (option of standbyModeOptions(); track $index) {
                                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="getErrorMessage('standbyMode') as errorMessage">{{ errorMessage }}</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            }

            @if (!isAnomalyReport && !isHCE) {
                <div class="col-sm-6">
                    <div class="horizontal-form-field">
                        <label class="form-label">
                            {{displayNames["justification"]}}
                            @if (!form().get('justification')?.disabled) {
                                <span class="required"></span>
                            }
                        </label>
                        <mat-form-field class="full-width">
                            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
                                      formControlName="justification"></textarea>
                            <mat-error *ngIf="getErrorMessage('justification') as errorMessage">{{ errorMessage }}</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            }

        </div>
    </mat-card-content>
</mat-card>
